export function timeout(ms) {
    return new Promise((resolve) => ms > 0 ? setTimeout(resolve, ms) : resolve());
}
